/* 🤖 this file was generated by svg-to-ts */
export const matIconMaximize: {
  name: 'maximize';
  data: string;
} = {
  name: 'maximize',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 3h18v2H3V3z"/></svg>`
};
